module.exports = __webpack_public_path__ + "static/media/COVID-Icons_Wash.417131e8.png";